import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";

const DeviceTable = ({ action, filter, dates, column }) => {
  const [deviceData, setDeviceData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [comments, setComments] = useState({});
  // const userDetails = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const fetchData = (page, limit, filter, action, dates) => {
    const userDetails = JSON.parse(localStorage.getItem("user"));

    if (!userDetails || !userDetails.token) {
      navigate("/logout");
    }

    if (
      action !== false &&
      (filter !== "" || (dates.startDate !== "" && dates.endDate !== ""))
    ) {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}devices-filter?page=${page}&limit=${limit}&filter=${filter}&startdate=${dates.startDate}&enddate=${dates.endDate}`,
          {
            headers: {
              Authorization: `Bearer ${userDetails.token}`,
            },
          }
        )
        .then((response) => {
          setDeviceData(response.data.result);
          setTotalRecords(response.data.totalRecords);
        })
        .catch((error) => {
          console.error("Error fetching devices data:", error);
        });
    } else if (filter) {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}devices-filter?page=${page}&limit=${limit}&filter=${filter}`,
          {
            headers: {
              Authorization: `Bearer ${userDetails.token}`,
            },
          }
        )
        .then((response) => {
          setDeviceData(response.data.result);
          setTotalRecords(response.data.totalRecords);
        })
        .catch((error) => {
          console.error("Error fetching devices data:", error);
        });
    } else {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}get-sms-device-list?page=${page}&limit=${limit}`,
          {
            headers: {
              Authorization: `Bearer ${userDetails.token}`,
            },
          }
        )
        .then((response) => {
          setDeviceData(response.data.result);
          setTotalRecords(response.data.totalRecords);
        })
        .catch((error) => {
          console.error("Error fetching devices data:", error);
        });
    }
  };

  useEffect(() => {
    fetchData(currentPage, rowsPerPage, filter, action, dates);

    // this is for local "process.env.REACT_APP_BASE_URL" and this for stage process.env.REACT_APP_BASE_URL_APP"
    // const socket = io(process.env.REACT_APP_BASE_URL_APP, {
    //   transports: ["websocket", "polling"],
    // });

    const socket = io(process.env.REACT_APP_BASE_URL_APP); //this use for prod env

    if (filter) {
      return () => {
        socket.disconnect();
      };
    }

    socket.on("otpSMSCreated", (data) => {
      // Clear the existing data and fetch fresh data from the server
      fetchData(currentPage, rowsPerPage, filter, action, dates); // Fetch the latest device record
    });

    return () => {
      socket.disconnect();
    };
  }, [filter, action, dates, column, currentPage, rowsPerPage]);

  useEffect(() => {
    setCurrentPage(1); // Reset to first page when filter or dates change
  }, [filter, action, dates]);

  const saveComment = (event, deviceId) => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (!userDetails || !userDetails.token) {
      navigate("/logout");
    }

    axios
      .post(
        process.env.REACT_APP_BASE_URL + "comment-create",
        {
          comment: event.target.value,
          device_id: deviceId,
        },
        {
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message);
        } else if (response.status === 202) {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        // toast.error(error.response.data.message[0]);
      });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    return moment.utc(dateString).format("YYYY-MM-DD hh:mm:ss A");
  };

  const deleteDevice = (id) => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (!userDetails || !userDetails.token) {
      navigate("/logout");
    }

    const isConfirmed = window.confirm(
      "Are you sure you want to delete this device?"
    );
    if (isConfirmed) {
      axios
        .get(`${process.env.REACT_APP_BASE_URL}delete-device/${id}`, {
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
          },
        })
        .then((response) => {
          toast.error(response.data.message);
          // Optionally refresh the data after deletion
          fetchData(currentPage, rowsPerPage, filter, action, dates);
        })
        .catch((error) => {
          toast.error(error.response.data.error);
        });
    }
  };

  const editDevice = (deviceId) => {
    navigate(`/devices/edit/${deviceId}`);
  };

  const copyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      alert("Otp copied to clipboard!"); // Optional: Confirmation alert
    } catch (err) {
      console.error("Unable to copy to clipboard", err);
    }
    document.body.removeChild(textArea);
  };

  const deviceColumns = [
    {
      name: "Sr No.",
      selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      width: "100px",
    },

    {
      name: "Description",
      selector: (row) => (
        <p
          className="description"
          title={row.description}
          style={{ cursor: "pointer" }}
        >
          {row.description.length > 10
            ? row.description.slice(0, 10) + "..."
            : row.description}
        </p>
      ),
    },
    {
      name: "OTP",
      // selector: (row) => (row.otp ? row.otp : "N/A"),
      selector: (row) => (
        <p
          className="description"
          title={row.otp}
          style={{ cursor: "pointer" }}
          onDoubleClick={() => copyToClipboard(row.otp)}
        >
          {row.otp.length > 0 ? row.otp.slice(0, 10) : row.otp}
        </p>
      ),
    },

    {
      name: "Device",
      selector: (row) =>
        row.device && row.device.name ? row.device.name : "N/A",
    },
    {
      name: "Bank Name",
      selector: (row) => (row.bank_name ? row.bank_name : "N/A"),
    },
    {
      name: "Account Title",
      selector: (row) => (row.account_title ? row.account_title : "N/A"),
    },
    {
      name: "Account Number",
      selector: (row) => (row.account_number ? row.account_number : "N/A"),
    },
    {
      name: "Department",
      selector: (row) =>
        row.department && row.department.name ? row.department.name : "N/A",
    },
    {
      name: "CreatedDate",
      selector: (row) => {
        if (!row.createdAt) return "";

        return formatDate(row.createdAt);
      },
    },
  ];

  return (
    <div>
      <ToastContainer containerId="containerB" />
      <DataTable
        columns={deviceColumns}
        data={deviceData}
        pagination
        paginationServer
        paginationDefaultPage={currentPage}
        paginationTotalRows={totalRecords}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleRowsPerPageChange}
        paginationPerPage={10} // Default rows per page
        paginationRowsPerPageOptions={[10, 25, 50, 100, 500, 1000]}
      />
    </div>
  );
};

export default DeviceTable;
